import { createFileRoute } from "@tanstack/react-router";
import { siteTitle } from "@/config/site";
import { cardMeta } from "@/lib/social-card-meta";
import { localeUrl, ogImageMeta } from "@/lib/seo";
import type { LocalizedMetaHeadContext } from "@/lib/route-head";
import type { FaqEntry } from "@/lib/jsonld";
import { SmartImportPage } from "@/components/smart-import-page";
import {
  PAGE_TITLE,
  PAGE_DESC,
  SMART_IMPORT_KEYWORDS,
  smartImportJsonLd,
  smartImportLoader,
} from "@/components/smart-import-meta";

export const Route = createFileRoute("/$locale/smart-import")({
  loader: smartImportLoader,
  head: ({
    params,
    loaderData,
  }: LocalizedMetaHeadContext & { loaderData?: { faqs?: FaqEntry[] } }) => {
    const canonicalUrl = localeUrl(params.locale, "/smart-import");
    const pageTitle = loaderData?.pageTitle ?? PAGE_TITLE;
    const pageDesc = loaderData?.pageDesc ?? PAGE_DESC;
    return {
      meta: [
        { title: `${pageTitle} | ${siteTitle}` },
        { name: "description", content: pageDesc },
        { name: "keywords", content: SMART_IMPORT_KEYWORDS },
        ...cardMeta({
          title: `${pageTitle} | ${siteTitle}`,
          description: pageDesc,
          canonicalUrl: canonicalUrl,
          locale: params.locale,
          twitterTitle: pageTitle,
        }),
        // Page-specific, locale-aware social card (keyed on translated title).
        ...ogImageMeta(pageTitle),
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: smartImportJsonLd(loaderData?.faqs ?? []),
        },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: SmartImportPage,
});
